import ContactSubscribedDisplay from './ContactSubscribedDisplay.container'
import ContactSubscribedForm from './ContactSubscribedForm.container'
import IconAccountPlus from 'components/Icons/AccountPlus'

export default {
  id: 'contact_subscribed',
  label: 'Contact Subscribed',
  helpUrl: 'https://help.thinkpickle.com.au/flows/triggers/contact-subscribed',
  icon: IconAccountPlus,
  inputs: [],
  outputs: [{}],
  display: ContactSubscribedDisplay,
  form: ContactSubscribedForm,
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/ContactSubscribed/index.js